import { ConsumerProfile } from '../../state'
import { joinStrings } from '@afterpay/utils/string'
import { FULL_NAME_MAX_LENGTH } from '../VerifyIdentity/constants'
import { createContext, useContext } from 'react'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { valueIsNotNullOrUndefined } from '@afterpay/utils'
import { IdentityErrorCode } from '@afterpaytouch/portal-api/identity'

export const isDifferentWithProfileDOB = (formDOB?: string, profileDOB?: string): boolean => {
  if (formDOB === undefined) {
    return false
  }
  return formDOB !== profileDOB
}

export const isDifferentWithProfileNames = (formInputValue: string, profile: Partial<ConsumerProfile> = {}): boolean => {
  if (formInputValue.length === 0 || formInputValue.length > FULL_NAME_MAX_LENGTH) {
    return false
  }

  const { givenNames, otherGivenNames, surname } = profile
  return formInputValue.toLowerCase() !== joinStrings([givenNames ?? '', otherGivenNames ?? '', surname ?? '']).toLowerCase()
}

export const IsRetryPageContext = createContext(false)

interface setErrorAndLog {
  error?: IdentityErrorCode
  lock: boolean
  event?: string
}

export const useSetErrorsAndLogEvent = (
  setError: (error: IdentityErrorCode | null) => void,
  setLock: (lock: boolean) => void,
  trackingEvent: string
): ((args: setErrorAndLog) => void) => {
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  return (args) => {
    const { error = null, event, lock } = args
    setError(error)
    setLock(lock)
    if (error === null && valueIsNotNullOrUndefined(event)) {
      logEvent(event)
    } else {
      logEvent(trackingEvent, { idvError: error ?? event })
    }
  }
}

export const useIsRetryPageContext = (): boolean => {
  return useContext(IsRetryPageContext)
}
